import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const peopleSlider = (): Swiper | null => {
  const el = document.querySelector<HTMLElement>(".p-top-people-list");
  if (!el) return null;

  return new Swiper(el, {
    modules: [Navigation, Pagination],
    slidesPerView: 1.4,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: ".p-top-people-list__arrow.--prev",
      prevEl: ".p-top-people-list__arrow.--next",
    },
    pagination: {
      el: ".p-top-people-list__pagination",
      type: "fraction",
      formatFractionCurrent: (number) => String(number).padStart(2, "0"),
      formatFractionTotal: (number) => String(number).padStart(2, "0"),
    },
    breakpoints: {
      768: {
        slidesPerView: 2.9,
      },
    },
  });
};
